import {useToast, UseToastOptions} from "@chakra-ui/toast";
import React, {useEffect} from "react";
import {Button, Card, Flex, Spacer, Text} from "@chakra-ui/react";
import {formatWeekdayList} from "../../tools/groupHours";
import {useTranslations} from "next-intl";

export function SelectToast(
    {checkedItems, onClear, onEdit}: {checkedItems: number[], onClear: (empty: number[]) => void, onEdit: () => void}
) {
    const toast = useToast()
    const toastIdRef = React.useRef()
    useEffect(() => {
        const options: UseToastOptions = {
            position: "bottom",
            isClosable: false,
            duration: null,
            status: "info",
            render(): React.ReactNode {
                return (<ToastContents checkedItems={checkedItems} onClear={onClear} onEdit={onEdit}/>)
            }
        }

        if (toastIdRef.current !== undefined) {
            if (checkedItems.length > 0) {
                toast.update(toastIdRef.current, options)
            } else {
                toast.close(toastIdRef.current)
                toastIdRef.current = undefined
            }
        } else {
            if (checkedItems.length > 0) {
                // @ts-ignore
                toastIdRef.current = toast(options)
            }
        }

    }, [checkedItems, onClear, onEdit, toast]);
    return <></>
}

function ToastContents({checkedItems, onClear, onEdit}: {checkedItems: number[], onClear: (empty: number[]) => void, onEdit: () => void}) {
    const t = useTranslations("addbar")
    return (
        <Card p="20px" variant="outline" >
            <Flex h="100%" align="center" gap={3}>
                <Text>
                    {formatWeekdayList(checkedItems.map(a => +a))}
                </Text>
                <Spacer/>
                <Button variant="secondary" onClick={onEdit}>
                    {t("edit")}
                </Button>
                <Button colorScheme="red" variant="error" onClick={() => onClear([])}>
                    {t("cancel")}
                </Button>
            </Flex>
        </Card>
    )
}